// Entry point for the build script in your package.json
import "./bugsnag";

// Rails UJS
import Rails from "@rails/ujs";
Rails.start();


import "./tooltips";
import "./tracking";
import "./ui";
import "./community";
